<script setup lang="ts">
import { useScrollGradient } from '@/sharedComposables/useScrollGradient'
import { ref } from 'vue'

type Props = {
  /**
   * Size of the fade gradients
   */
  fadeSize?: 'md' | 'lg' | 'xl'
  /**
   * Distance in pixels over which the fade effect transitions
   */
  fadeDistance?: number
  tag?: string
}

const props = withDefaults(defineProps<Props>(), {
  fadeSize: 'md',
  fadeDistance: 40,
  tag: 'div',
})

const scrollContainer = ref<HTMLElement>()
const maskStyle = useScrollGradient(scrollContainer, props)
</script>

<template>
  <!-- Scroll container with edge fade effects -->
  <component
    :is="props.tag"
    ref="scrollContainer"
    class="go-scrollbar shrink grow overflow-auto"
    :style="maskStyle"
  >
    <slot :scroll-container="scrollContainer" />
  </component>
</template>
